import { render, staticRenderFns } from "./msdsHardcoding.vue?vue&type=template&id=a19357ee"
import script from "./msdsHardcoding.vue?vue&type=script&lang=js"
export * from "./msdsHardcoding.vue?vue&type=script&lang=js"
import style0 from "./msdsHardcoding.vue?vue&type=style&index=0&id=a19357ee&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a19357ee')) {
      api.createRecord('a19357ee', component.options)
    } else {
      api.reload('a19357ee', component.options)
    }
    module.hot.accept("./msdsHardcoding.vue?vue&type=template&id=a19357ee", function () {
      api.rerender('a19357ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/msds/msdsHardcoding.vue"
export default component.exports